import { render, staticRenderFns } from "./article-waterfall.vue?vue&type=template&id=af33ac32&scoped=true"
import script from "./article-waterfall.vue?vue&type=script&lang=js"
export * from "./article-waterfall.vue?vue&type=script&lang=js"
import style0 from "./article-waterfall.vue?vue&type=style&index=0&id=af33ac32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af33ac32",
  null
  
)

export default component.exports